module.exports = __webpack_public_path__ + "img/arc.f2407fae.png";